module.exports = __webpack_public_path__ + "static/media/s-gofr1.bcbc2b3b.png";